// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4fb69a98","55":"39ddc029","147":"c9e42013","171":"a24b2154","441":"9907c221","453":"be75aed1","574":"3dae4ffa","599":"2e0f148b","759":"d921d6ad","763":"8dbe1d59","780":"e67fa15f","845":"60ad5bac","923":"513322aa","976":"6dc73f0c"}[chunkId] + ".chunk.js";
};